var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-csv-container"},[_c('Typography',{attrs:{"variant":"h-2"}},[_vm._v("Upload your CSV file")]),_c('CSVDragAndDrop',{attrs:{"file":_vm.file,"columns":_vm.columns},on:{"file-selected":function($event){return _vm.$emit('file-changed', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }